/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Selected_ListInputs */

const en_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Selected List`)
};

const fr_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la liste sélectionnée`)
};

const de_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Liste entfernen`)
};

const it_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi elenco selezionato`)
};

const ru_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить выбранный список`)
};

const es_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar lista seleccionada`)
};

const zh_cn2_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除已选列表`)
};

const ja_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したリストを削除`)
};

const hi_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित सूची हटाएं`)
};

const pt_pt2_remove_selected_list = /** @type {(inputs: Remove_Selected_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover lista selecionada`)
};

/**
* | output |
* | --- |
* | "Remove Selected List" |
*
* @param {Remove_Selected_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_selected_list = /** @type {((inputs?: Remove_Selected_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Selected_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_selected_list(inputs)
	if (locale === "de") return de_remove_selected_list(inputs)
	if (locale === "it") return it_remove_selected_list(inputs)
	if (locale === "ru") return ru_remove_selected_list(inputs)
	if (locale === "es") return es_remove_selected_list(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_selected_list(inputs)
	if (locale === "ja") return ja_remove_selected_list(inputs)
	if (locale === "hi") return hi_remove_selected_list(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_selected_list(inputs)
	return en_remove_selected_list(inputs)
});